import api from './index';

export const updateProperty = data => api.putForm('/properties', data);
export const updateApartment = data => api.put('/apartments', data);
export const updateHotel = data => api.put('/hotels', data);
export const updateHotelRooms = data => api.putForm('/hotel-rooms', data);
export const findProperty = (propertyId, select, populate) =>
  api.get(
    `/properties/find/${propertyId}${select || populate ? '?' : ''}${
      select ? 'select=' + select : ''
    }${select && populate ? '&' : ''}${populate ? 'populate=' + populate : ''}`
  );

export const findApartment = (propertyId, select) =>
  api.get(`/apartments/${propertyId}${select ? '?select=' + select : ''}`);

export const findHotel = (propertyId, select) =>
  api.get(`/hotels/${propertyId}${select ? '?select=' + select : ''}`);

export const findHotelRoom = (propertyId, roomName, select) =>
  api.get(
    `/hotel-rooms/${propertyId}/${roomName}${select ? '?select=' + select : ''}`
  );

export const findDistinctRooms = (propertyId, select, roomName) =>
  api.get(
    `/hotel-rooms/${propertyId}/distinct${select ? '?select=' + select : ''}`
  );
export const fetchHotelRooms = propertyId => api.get(`/hotel-rooms/${propertyId}`);
export const importRoomPhotos = data =>
  api.post('/properties/photos/import-from-rooms', data);
export const deleteHotelRooms = (propertyId, roomName) =>
  api.delete(`/hotel-rooms/${propertyId}/${roomName}`);

export const fetchMyProperties = ({ select, type, status }) =>
  api.get(
    `/properties/my-properties${'?select=' + select}${'&type=' + type}${
      '&status=' + status
    }`
  );


export const fetchHouseRules = (propertyType) => api.get(`/house-rules?propertyType=${propertyType}&status=active`)

// automatic enrollment: queue a hotel to be imported from its Booking.com listing
export const requestBookingScrape = data =>
  api.post('/properties/booking-scrape', data);
